import GET_TASK_DETAILS from '@/brain/board/get-task-details'
import GET_EVENT_DETAILS from '@/brain/board/get-event-details'
import OPEN_TASK from '@/brain/board/open-task'
import FINISH_TASK from '@/brain/board/finish-task'
import TASK_PARTICIPATE from '@/brain/board/task-participate'
import ADD_RESPONSIBLE_USER from '@/brain/board/add-responsible-user'
import REMOVE_RESPONSIBLE_USER from '@/brain/board/remove-responsible-user'
import LIST_BOARDS from '@/brain/board/list-boards'
import SET_WAIT_NEW_DATE from '@/brain/board/set-wait-new-date'
import SET_WAIT_WITHOUT_DATE from '@/brain/board/set-wait-without-date'
import SET_REMOVE_WAIT_WITHOUT_DATE from '@/brain/board/set-remove-wait-without-date'
import CANCEL_EVENT from '@/brain/board/cancel-event'
import LOAD_SHEET from '@/brain/board/board-sheet'
import ANALYSE_TASK from '@/brain/board/analyse-task'
import INPROGRESS_STATUS from '@/brain/board/in-progress-status'
import CHAT_PUSH_MESSAGE from '@/brain/board/chat-push-message'
import CHAT_LIST_MESSAGES from '@/brain/board/chat-list-messages'
import LOAD_RESULT from '@/brain/board/load-result'

export default {
  GET_TASK_DETAILS,
  OPEN_TASK,
  FINISH_TASK,
  TASK_PARTICIPATE,
  ADD_RESPONSIBLE_USER,
  REMOVE_RESPONSIBLE_USER,
  LIST_BOARDS,
  GET_EVENT_DETAILS,
  ANALYSE_TASK,
  SET_WAIT_NEW_DATE,
  SET_WAIT_WITHOUT_DATE,
  SET_REMOVE_WAIT_WITHOUT_DATE,
  CANCEL_EVENT,
  LOAD_SHEET,
  INPROGRESS_STATUS,
  CHAT_PUSH_MESSAGE,
  CHAT_LIST_MESSAGES,
  LOAD_RESULT
}



// WEBPACK FOOTER //
// ./src/view/board/state/actions.js